import React from "react";
import "../../App.css";
import NavbarComp from "../navbar/navbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

class Contact extends React.Component {
  render() {
    return (
      <div className="container d-flex justify-content-center mt-5">
        <div className="centered-box w-lg-75 w-100">
          <NavbarComp />

          <div className="row">
            <div className="mt-3" id="contact">
              <h5>Contact</h5>
              <hr />

              <p style={{ marginBottom: "1.5rem" }}>
                If you would like to discuss backend systems, distributed
                platforms, or real time applications, feel free to reach out.
              </p>

              <ul className="list-group">
                <li className="list-group-item">
                  <p style={{ marginBottom: 0 }}>
                    <FontAwesomeIcon icon={faEnvelope} size="lg" /> &nbsp;
                    <a
                      href="mailto:chavansubhed@gmail.com"
                      style={{
                        color: "#168f7c",
                        textDecoration: "none",
                      }}
                    >
                      chavansubhed@gmail.com
                    </a>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Contact;
